import React from 'react';
import PixiScaledSprite from "./PixiScaledSprite"
import PixiScaledText from "./PixiScaledText"
import { Container } from '@pixi/react';
import PixiGamePositionRibbon from "./PixiGamePositionRibbon"

class PixiEndGamePlayerInfoRow extends React.Component
{
  textStyle = {
    fill: "#111111"
  };

  render()
  {
    const stageRenderData = this.props.stageRenderData;
    const renderScale = stageRenderData.scale;
    const isClientPlayerRow = this.props.isClientPlayerRow;
    const positionIndex = this.props.positionIndex;
    const playerIconSprite = this.props.playerIconSprite;

    const featureScoreFontSize = 18;

    const score = this.props.score;
    const roadScore = this.props.roadScore ?? 0;
    const cityScore = this.props.cityScore ?? 0
    const cloisterScore = this.props.cloisterScore ?? 0;
    const fieldScore = this.props.fieldScore ?? 0;

    return (

      <Container
        x={ this.props.x }
        y={ this.props.y }
      >
        { isClientPlayerRow &&
          (
            <PixiScaledSprite
              imageSrc={ "./ui/panel_bg.png" }
              isNineSlice={ true }
              cornerRadius={ 15 }
              tint={ 0xdddddd }
              stageRenderData={ stageRenderData }
              x={ 10 * renderScale }
              y={ 0 }
              width={ 780 }
              height={ 70 }
              anchor={ { x: 0, y: 0 } }
            />
          )
        }

        <PixiGamePositionRibbon
          keyName={ `position-tab-ribbon-${positionIndex}` }
          x={ 50 * renderScale }
          y={ ( this.props.height / 2 ) }
          positionIndex={ positionIndex }
          stageRenderData={ stageRenderData }
          scale={ 0.8 }
        />


        <PixiScaledSprite
          imageSrc={ playerIconSprite }
          stageRenderData={ stageRenderData }
          x={ 105 * renderScale }
          y={ ( this.props.height / 2 ) }
          width={ 40 }
          height={ 40 }
          anchor={ { x: 0.5, y: 0.5 } } />

        <PixiScaledText
          text={ this.props.playerName }
          stageRenderData={ stageRenderData }
          x={ 135 * renderScale }
          y={ ( this.props.height / 2 ) }
          anchor={ { x: 0, y: 0.5 } }
          style={ this.textStyle }
          fontSize={ 18 }
        />

        <PixiScaledText
          text={ roadScore }
          stageRenderData={ stageRenderData }
          x={ 360 * renderScale }
          y={ ( this.props.height / 2 ) }
          anchor={ { x: 0.5, y: 0.5 } }
          style={ this.textStyle }
          fontSize={ featureScoreFontSize }
        />

        <PixiScaledText
          text={ cityScore }
          stageRenderData={ stageRenderData }
          x={ 440 * renderScale }
          y={ ( this.props.height / 2 ) }
          anchor={ { x: 0.5, y: 0.5 } }
          style={ this.textStyle }
          fontSize={ featureScoreFontSize }
        />

        <PixiScaledText
          text={ cloisterScore }
          stageRenderData={ stageRenderData }
          x={ 520 * renderScale }
          y={ ( this.props.height / 2 ) }
          anchor={ { x: 0.5, y: 0.5 } }
          style={ this.textStyle }
          fontSize={ featureScoreFontSize }
        />

        <PixiScaledText
          text={ fieldScore }
          stageRenderData={ stageRenderData }
          x={ 600 * renderScale }
          y={ ( this.props.height / 2 ) }
          anchor={ { x: 0.5, y: 0.5 } }
          style={ this.textStyle }
          fontSize={ featureScoreFontSize }
        />

        <PixiScaledText
          text={ score }
          stageRenderData={ stageRenderData }
          x={ 705 * renderScale }
          y={ ( this.props.height / 2 ) }
          anchor={ { x: 0.5, y: 0.5 } }
          style={ {
            fill: 'white',
            stroke: 'black',
            strokeThickness: 3,
          } }
          fontSize={ 23 }
        />

      </Container>

    );
  }
}

export default PixiEndGamePlayerInfoRow;
